// extracted by mini-css-extract-plugin
export default {"button":"AddSelectedImagesToDesign_button__oS35t","buttonText":"AddSelectedImagesToDesign_buttonText__SSwjq"};